<template>
  <div class="camera-setting-component">
    <div class="check-item camera-box">
      <div class="check-item__title">摄像头</div>
      <div class="check-item__content">
        <el-select
          v-model="camera"
          placeholder="请选择"
          popper-class="device-check-popper"
          class="live-room-el-select"
          :disabled="
            userStatus.is_up_stage !== 1 ||
            (userStatus.is_send_video !== 1 && roomInfo.isStudent)
          "
        >
          <el-option
            v-for="item in cameraOptions"
            :key="item.deviceId"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
        <template v-if="camera !== 'disabled'">
          <div class="mirror-wrap">
            <el-checkbox v-model="isMirrorValue">镜像模式</el-checkbox>
          </div>
          <div class="camera-preview-box">
            <div class="camera-preview" ref="cameraPreview"></div>
            <!-- 无用 -->
            <div
              class="camera-default"
              v-if="false && deviceSwtich.camera === 'off'"
            >
              <img :src="userInfo.avatar" alt="" />
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-if="camera !== 'disabled'" class="beauty-setting">
      <div class="switch-wrap">
        <span class="item-title">美颜设置</span>
        <el-switch
          v-model="openBeautyValue"
          :active-value="true"
          :inactive-value="false"
          active-color="#165DFF"
          inactive-color="#3F3F46"
        ></el-switch>
      </div>
      <template v-if="openBeautyValue">
        <div
          class="beauty-item"
          v-for="item in beautySettings"
          :key="item.name"
        >
          <label>{{ item.label }}</label>
          <el-slider
            class="slider-box"
            :value="beautyOptions[item.name]"
            @input="(val) => handleSliderInput(val, item.name)"
          ></el-slider>
          <span class="value">
            {{ beautyOptions[item.name] }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import testClient from "@saas/pages/src/live/mixins/test-client.js";
export default {
  mixins: [testClient],
  data() {
    return {
      beautySettings: [
        {
          name: "beauty",
          label: "美颜",
        },
        {
          name: "brightness",
          label: "美白",
        },
        {
          name: "ruddy",
          label: "红润",
        },
      ],
    };
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "cameraList",
      "deviceSwtich",
      "currentCameraDevice",
      "isMirror",
      "openBeauty",
      "beautyOptions",
      "videoPermission",
      "userStatus",
      "roomInfo",
    ]),
    isMirrorValue: {
      get() {
        return this.isMirror;
      },
      set(value) {
        this.liveService.setMirror(value);
      },
    },
    openBeautyValue: {
      get() {
        return this.openBeauty;
      },
      set(value) {
        if (value) {
          this.liveService.startBasicBeauty(this.beautyOptions);
        } else {
          this.liveService.stopBasicBeauty();
        }
      },
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    cameraOptions() {
      return [...this.cameraList, { deviceId: "disabled", deviceName: "禁用" }];
    },
    camera: {
      get() {
        if (this.videoPermission === false) {
          return "disabled";
        } else if (this.deviceSwtich?.camera === "on") {
          // 打开-判断打开的是什么设备
          if (
            this.currentCameraDevice?.deviceId &&
            this.currentCameraDevice?.deviceId !== "disabled"
          ) {
            return this.currentCameraDevice?.deviceId;
          } else if (this.cameraList?.[0]?.deviceId) {
            return this.cameraList?.[0]?.deviceId;
          } else {
            return null;
          }
        } else {
          return "disabled";
        }
      },
      set(value) {
        this.changeCamera(value);
      },
    },
  },
  watch: {
    currentCameraDevice: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            if (newVal !== "disabled" && this.camera !== "disabled") {
              this.handleStartLocalPreviewByTestClient({
                dom: this.$refs.cameraPreview,
                deviceId: newVal.deviceId,
              });
            }
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", [
      "setCurrentCameraDevice",
      "setDeviceSwtich",
      "setUserStatus",
    ]),
    // 动态获取计算属性值
    getComputedValue(key) {
      return this[key];
    },
    handleSliderInput(val, name) {
      if (this.beautyOptions[name] === val) return;
      this.liveService.updateBasicBeauty({
        ...this.beautyOptions,
        [name]: val,
      });
    },
    // 切换摄像头
    changeCamera(device) {
      if (this.videoPermission === false) {
        this.$darkMessage.error("摄像头权限未开启，请开启后刷新页面重试！");
        return;
      }
      const deviceInfo = this.cameraOptions.find(
        (item) => item.deviceId === device
      );
      if (device === "disabled") {
        this.handleStopLocalPreviewByTestClient();
        this.setDeviceSwtich({
          camera: "off",
        });
        this.setUserStatus({
          video_state: 2,
        });
      } else {
        this.handleSetCurrentCameraDeviceByTestClient({
          deviceId: device,
        })
          .then(() => {
            this.setCurrentCameraDevice(deviceInfo);
            if (this.userStatus.is_up_stage === 1) {
              this.liveService.startLocalPreview({
                publish: true,
              });
            }
            this.handleStartLocalPreviewByTestClient({
              dom: this.$refs.cameraPreview,
            });
          })
          .catch((err) => {
            console.error("changeCamera___setCurrentCameraDevice_catch", err);
          });
        this.setDeviceSwtich({
          camera: "on",
        });
        if (
          this.userStatus.is_up_stage === 1 &&
          this.userStatus.is_send_video === 1
        ) {
          this.setUserStatus({
            video_state: 1,
          });
        }
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.camera-setting-component {
  .beauty-setting {
    font-weight: 500;
    font-size: 16px;
    color: #ecedee;
    line-height: 1;
  }
  .mirror-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    ::v-deep .el-checkbox {
      display: flex;
      align-items: center;
      .el-checkbox__label {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
      }
      .el-checkbox__input {
        margin-top: 2px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #165dff;
        border-color: transparent;
      }
      .el-checkbox__inner {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        margin-right: 0;
        border-color: #86909c;
        background: transparent;
      }
    }
  }
  .check-item {
    position: relative;
    margin-bottom: 12px;
    .check-item__title {
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
  .camera-box {
    .camera-preview-box {
      position: relative;
      width: 400px;
      height: 235px;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px 12px 12px 12px;
      overflow: hidden;
      .camera-default {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #27272a;
        img {
          width: 93px;
          height: 93px;
          border-radius: 50%;
        }
      }
      .camera-preview ::v-deep {
        width: 100%;
        height: 100%;
        video {
          max-width: none;
        }
      }
    }
    .el-select ::v-deep {
      width: 100%;
      margin-bottom: 12px;
      background: #27272a;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px 12px 12px 12px;
      &:hover {
        background: #3f3f46;
        .el-input__inner {
          background: #3f3f46;
        }
      }
      .el-input__inner {
        background: #27272a;
        border: none;
        color: #c9cdd4;
      }
    }
    .select-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        margin: 0;
      }
      .check-btn__speaker ::v-deep {
        width: 90px;
        height: 40px;
        background: #18181b;
        border: 1px solid rgba(63, 63, 70, 0.4);
        border-radius: 12px 12px 12px 12px;
        margin-left: 12px;
        color: #ffffff;
        font-size: 14px;
        color: #e8f3ff;
        padding: 0;
        span {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }

        &:hover {
          background: #0e42d2;
        }
      }
      .check-btn__speaker--play {
        background: #0e42d2;
      }
    }
    .slider-box ::v-deep {
      flex: 1;
      .el-slider__runway {
        background: #52525b;
        height: 8px;
      }
      .el-slider__bar {
        background: #165dff;
        height: 8px;
      }
      .el-slider__button-wrapper {
        .el-slider__button {
          width: 18px;
          height: 18px;
          background: #18181b;
          border: 2px solid #165dff;
        }
      }
    }
  }
  .switch-wrap {
    background: #27272a;
    border-radius: 12px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 12px;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #ecedee;
      line-height: 1;
    }
  }

  .beauty-item {
    display: flex;
    align-items: center;
    label {
      font-weight: 400;
      font-size: 14px;
      color: #ecedee;
      line-height: 20px;
      margin-right: 12px;
    }
    .value {
      font-weight: 400;
      font-size: 14px;
      color: #ecedee;
      line-height: 20px;
      margin-left: 12px;
    }
  }
}

::v-deep .el-switch__core {
  width: 54px !important;
  height: 30px;
  border: none;
  border-radius: 15px;
  &::after {
    width: 24px;
    height: 24px;
    top: 3px;
    left: 2px;
  }
}
::v-deep .el-switch.is-checked .el-switch__core::after {
  margin-left: -26px !important;
}
.slider-box ::v-deep {
  flex: 1;
  .el-slider__runway {
    background: #52525b;
    height: 8px;
  }
  .el-slider__bar {
    background: #165dff;
    height: 8px;
  }
  .el-slider__button-wrapper {
    .el-slider__button {
      width: 18px;
      height: 18px;
      background: #18181b;
      border: 2px solid #165dff;
    }
  }
}
</style>
